const messages = {
    en: {
        register: "Sign up",
    },
    ru: {
        register: "3арегистрироваться",
    }
  };

  export default messages;